// File: Clients/webcalendar/src/components/layout/MasterLayout/MasterLayout.jsx
import React from 'react';
import { Stack, styled, classNamesFunction } from '@fluentui/react';
import { Sidebar } from '../Sidebar';
import { TopMenu } from '../TopMenu';
import './MasterLayout.css'; // Import the CSS file

const getStyles = ({ theme }) => {
  return {
    root: 'master-layout-root', // Use class names instead of inline styles
    sidebar: 'master-layout-sidebar',
    contentWrapper: 'master-layout-content-wrapper'
  };
};

const getClassNames = classNamesFunction();

function MasterLayoutComponent({ children, theme, styles, routes }) {
  const classNames = getClassNames(styles, { theme });
  return (
    <Stack horizontal className={classNames.root}>
      <Stack.Item grow={false} className={classNames.sidebar}>
        <Sidebar routes={routes} />
      </Stack.Item>
      <Stack.Item grow={true} className='master-layout-content'>
        <TopMenu />
        <Stack className={classNames.contentWrapper}>{children}</Stack>
      </Stack.Item>
    </Stack>
  );
}

export const MasterLayout = styled(MasterLayoutComponent, getStyles);
